export default __webpack_public_path__ + "static/media/00_mode_completed.c2ff219c.mp3";